import { render, staticRenderFns } from "./Endoso.vue?vue&type=template&id=bf232418&"
import script from "./Endoso.vue?vue&type=script&lang=js&"
export * from "./Endoso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports